import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaTimes } from "react-icons/fa";

const ChatModal = ({ onClose }) => {
  const [messages, setMessages] = useState([
    { text: "Hi there! How can I Assist you today?", sender: "bot" }
  ]);
  const [input, setInput] = useState("");

  const handleSend = (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const newMessage = { text: input, sender: "user" };
    setMessages((prev) => [...prev, newMessage]);

    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        { text: "Thank you! We'll respond shortly.", sender: "bot" }
      ]);
    }, 800);

    setInput("");
  };

  return (
    <motion.div
      className="fixed bottom-24 right-4 z-50 w-80 md:w-96 bg-white rounded-lg shadow-xl border overflow-hidden"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 40 }}
      transition={{ duration: 0.3 }}
    >
      {/* Header */}
      <div className="flex justify-between items-center px-4 py-2 bg-blue-600 text-white">
        <h3 className="text-lg font-semibold">Glide Assistant</h3>
        <button onClick={onClose}>
          <FaTimes />
        </button>
      </div>

      {/* Messages */}
      <div className="h-64 p-4 overflow-y-auto space-y-2 text-sm bg-gray-50">
        {messages.map((msg, idx) => (
          <div
            key={idx}
            className={`px-3 py-2 rounded-md max-w-[80%] ${
              msg.sender === "user"
                ? "bg-blue-100 self-end ml-auto"
                : "bg-gray-200"
            }`}
          >
            {msg.text}
          </div>
        ))}
      </div>

      {/* Input */}
      <form onSubmit={handleSend} className="flex items-center p-2 border-t">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="flex-1 px-3 py-2 text-sm border rounded focus:outline-none"
          placeholder="Type a message..."
        />
        <button
          type="submit"
          className="ml-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm"
        >
          Send
        </button>
      </form>
    </motion.div>
  );
};

export default ChatModal;
